import { useQuery } from '@apollo/client';
import AddIcon from '@mui/icons-material/Add';
import { IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import GridWrapper from 'lib/GridWrapper';
import Page from 'components/Page';
import { packagesQuery } from './queries';
import { PackagesQuery, PackagesQueryVariables } from './types/queries';

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 400,
    type: 'string',
  },
  {
    field: 'featuresQty',
    headerName: 'Features',
    filterable: false,
    width: 150,
    type: 'number',
  },
  {
    field: 'serversQty',
    headerName: 'Servers',
    filterable: false,
    width: 150,
    type: 'number',
  },
  {
    field: 'features',
    headerName: 'Features',
    filterable: false,
    minWidth: 200,
    resizable: true,
    type: 'string',
  },
];

const PackagesPage: FC = () => {
  const nav = useNavigate();
  const { data, loading } = useQuery<PackagesQuery, PackagesQueryVariables>(
    packagesQuery
  );

  const viewData = useMemo(
    () =>
      data?.packages.map((p) => {
        const features = p.features?.map((f) => f.name);

        return { ...p, features: features?.join(', ') };
      }) ?? [],
    [data?.packages]
  );

  return (
    <Page
      title="Packages"
      options={
        <Tooltip title="New Package">
          <IconButton
            style={{ color: 'white' }}
            onClick={() => nav('/admin/packages/new')}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      }
    >
      <GridWrapper
        columns={columns}
        rows={viewData}
        loading={loading}
        basePath="/admin/packages/"
        initialSort={[{ field: 'featuresQty', sort: 'desc' }]}
      />
    </Page>
  );
};

export default PackagesPage;
